<template>
    <mds-layout-grid>
        <mds-row e2e="transactions-summary">
            <mds-col :cols="3">
                <mds-label size="small" :text="getUILabel('transactions_contribution')">
                    <mds-microcopy size="small">
                        <span v-html="contributionSummary"></span>
                    </mds-microcopy>
                </mds-label>
            </mds-col>
            <mds-col :cols="3">
                <mds-label size="small" :text="this.getUILabel('transactions_withdrawal')">
                    <mds-microcopy size="small">
                        <span v-html="withdrawalSummary"></span>
                    </mds-microcopy>
                </mds-label>
            </mds-col>
            <mds-col :cols="3" :pull="3">
                <mds-label size="small" :text="this.getUILabel('liquidate_on_end_date')">
                    <mds-microcopy size="small">{{ liquidateOnEndDate }}</mds-microcopy>
                </mds-label>
            </mds-col>
        </mds-row>
    </mds-layout-grid>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";
import MdsLabel from "@mds/label";
import MdsMicrocopy from "@mds/microcopy";
export default {
    name: "transactions-summary",
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    components: {
        MdsLayoutGrid,
        MdsRow,
        MdsCol,
        MdsLabel,
        MdsMicrocopy
    },
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            }
        };
    },
    computed: {
        liquidateOnEndDate() {
            const labelId = this.$store.state.transaction.liquidateOnEndDate ? "transactions_yes" : "transactions_no";
            return this.getUILabel(labelId);
        },
        contributionRecordsNum() {
            return this.$store.getters["transaction/contributionRecordsNum"];
        },
        withdrawalRecordsNum() {
            return this.$store.getters["transaction/withdrawalRecordsNum"];
        },
        contributionSummary() {
            if (this.contributionRecordsNum === 0) {
                return "&mdash;";
            } else if (this.contributionRecordsNum === 1) {
                return `${this.contributionRecordsNum} ${this.getUILabel("transaction")}`;
            } else {
                return `${this.contributionRecordsNum} ${this.getUILabel("transactions")}`;
            }
        },
        withdrawalSummary() {
            if (this.withdrawalRecordsNum === 0) {
                return "&mdash;";
            } else if (this.withdrawalRecordsNum === 1) {
                return `${this.withdrawalRecordsNum} ${this.getUILabel("transaction")}`;
            } else {
                return `${this.withdrawalRecordsNum} ${this.getUILabel("transactions")}`;
            }
        }
    }
};
</script>
